import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CURRENT_DATE_FORMAT_WITH_HOURS } from "common/utils/constants"
import { formatDate } from "common/utils/date"
import { FLOW_STATUS_SUCCESS } from "features/Validaciones/pages/Documentos/constant"

const DetailStepStatus = ({
  children,
  status,
  icon,
  date,
  description,
}: {
  children: React.ReactNode
  status?: string
  icon?: IconName
  date: string
  description: string
}) => {
  return (
    <li className='tw-gap-2 tw-flex tw-flex-col tw-relative tw-my-2 tw-mx-0 before:tw-content-[""] before:tw-absolute before:tw-top-[18px] before:tw-left-[5px] before:tw-h-[80%] before:tw-w-0.5 before:tw-border-r-2 before:tw-border-dotted before:tw-border-[#c1b8b8] last:before:tw-content-[""] last:before:tw-absolute last:before:tw-border-r-0'>
      <div className='tw-flex tw-justify-between'>
        <div className='tw-text-sm tw-flex tw-gap-1 tw-items-center'>
          <span
            className={`tw-flex tw-items-center tw-justify-center tw-rounded- tw-relative tw-h-3 tw-w-3 `}
          >
            {icon ? (
              <FontAwesomeIcon
                className={`tw-w-full ${
                  status === FLOW_STATUS_SUCCESS
                    ? "tw-text-secondary"
                    : "tw-text-danger"
                }`}
                icon={["fal", `${icon}`]}
              />
            ) : null}
          </span>
          {children}
        </div>
        <div className='tw-flex tw-justify-end tw-text-xs'>
          {formatDate(date, CURRENT_DATE_FORMAT_WITH_HOURS)}
        </div>
      </div>
      <p className='!tw-mx-5 !tw-mb-2 tw-break-words tw-max-w-100 tw-min-w-60 tw-text-xs'>
        {description}
      </p>
    </li>
  )
}

export default DetailStepStatus
